/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import Input from './Input';
import { Image } from 'react-native-elements';

const InputPassword = (props) => {
  const [isShowPassowrd, setIsShowPassord] = useState(false);
  const iconReveal = isShowPassowrd
    ? require('@assets/img/icons/reveal-show.png')
    : require('@assets/img/icons/reveal-hide.png');
  const onPressShowPassword = () => {
    setIsShowPassord(!isShowPassowrd);
  };

  return (
    <Input
      {...props}
      secureTextEntry={!isShowPassowrd}
      rightIcon={
        isShowPassowrd ? (
          <Image
            testID="icon-hide-password"
            style={styles.icon}
            source={iconReveal}
            onPress={onPressShowPassword}
          />
        ) : (
          <Image
            testID="icon-show-password"
            style={styles.icon}
            source={iconReveal}
            onPress={onPressShowPassword}
          />
        )
      }
    />
  );
};

const styles = StyleSheet.create({
  icon: {
    width: 23,
    height: 14,
  },
});

export default React.memo(InputPassword, (prev, next) => prev == next);
